import { Controller } from 'react-hook-form';
import { Alert, Box, FormInputText, InputLabel, Select } from '@hopskipdrive/react-components';

import { useAdjustedArrivalReasons } from '../../../hooks/useAdjustedArrivalReasons';

export const AdjustedArrivalFormField = ({ control, errors }) => {
  const { data: reasonsResult } = useAdjustedArrivalReasons();
  const reasons = reasonsResult?.data.map((reason) => ({
    label: reason[1],
    value: reason[0],
  }));

  return (
    <FormFieldContent>
      <InputLabel fieldtype="required" htmlFor="adjustedArrivalReason">
        Adjusted Arrival Reason
      </InputLabel>
      <Controller
        control={control}
        name={'adjustmentReasonKey'}
        render={({ field: { value, onChange } }) => (
          <Select
            options={reasons || []}
            value={value}
            setValue={onChange}
            style={{ width: '447px' }}
            renderInput={(params) => (
              <FormInputText
                {...params}
                variant="outlined"
                data-testid="adjustedArrivalReason"
                placeholder="Select a reason"
                error={!!errors.adjustmentReasonKey}
                helperText={errors?.adjustmentReasonKey && errors?.adjustmentReasonKey?.message}
              />
            )}
          />
        )}
      />
      <Alert
        severity="info"
        variant="standard"
        data-testid="adjustedArrivalReasonAlert"
        title="Adjusted Arrival Reason is required when:"
        icon={false}
        message={
          <>
            <p>• Start time is less than 2 hours from the time user makes the adjustment.</p>
            <p>• Ride anchor time is adjusted by 15 minutes or more.</p>
          </>
        }
        style={{ marginTop: '12px' }}
      />
    </FormFieldContent>
  );
};

const FormFieldContent = ({ children }) => (
  <Box display="flex" flexDirection="column">
    {children}
  </Box>
);
